import TestStore from './TestStore';
import UnAuthentStore from './UnAuthentStore';
export default function initStores(type:string='') {
    const stores:{
        [key:string]:object;
        TestStore:typeof TestStore;
        UnAuthentStore:typeof UnAuthentStore;
    } = {
        TestStore,
        UnAuthentStore
    }
    return type ? stores[type]:stores
}